import { Text } from '@vkontakte/vkui';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import autoUploadModalImage from 'img/webAutoUpload/auto-upload-modal.png';
import autoUploadModalImageDark from 'img/webAutoUpload/auto-upload-modal-dark.png';
import React from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './AutoUploadModal.css';

// определяет тип фримиума для аналитики
const getFreemiumTypeForAnalytics = (): 'soft' | 'hard' | 'trial' => {
    const freemiumTypeParam = getFeature('freemium-type') as 'soft' | 'hard' | undefined;
    if (freemiumTypeParam === 'soft') {
        return 'soft';
    }
    if (freemiumTypeParam === 'hard') {
        return 'hard';
    }
    return 'trial';
};

// получает имя для аналитики модалки автозагрузки
const getAutoUploadModalAnalyticsName = (): string => {
    const type = getFreemiumTypeForAnalytics();
    if (type === 'soft') {
        return 'family_onboarding_unlimited_info_soft_freemium';
    }
    if (type === 'hard') {
        return 'family_onboarding_unlimited_info_hard_freemium';
    }
    return 'family_onboarding_unlimited_info_trial';
};

export const renderAutoUploadModal = (options?: { reopenFreemiumAboutModal?: boolean; renderFreemiumAboutModal?: () => void }): void => {
    const analyticsName = getAutoUploadModalAnalyticsName();
    const { reopenFreemiumAboutModal = false, renderFreemiumAboutModal } = options || {};

    sendDwh({
        eventCategory: 'modal',
        action: 'show',
        dwh_enabled: true,
        dwhData: {
            name: analyticsName,
        },
    });

    renderCommonWhatsNewDialog({
        title: 'Как включить безлимитную автозагрузку',
        titleClassName: styles.modalTitle,
        content: (
            <div className={styles.items}>
                <Text className={styles.text}>
                    <strong>1.</strong> Скачайте приложение Облака на телефон
                </Text>
                <Text className={styles.text}>
                    <strong>2.</strong> Откройте настройки аккаунта в приложении и включите безлимитную автогрузку
                </Text>
                <Text className={styles.text}>
                    <strong>3.</strong> Пока вы держите вкладку приложения открытой, фото и видео с телефона сами загружаются в Облако. Они
                    сохраняются там безлимитно и не занимают место в общем объёме памяти
                </Text>
            </div>
        ),
        imageUrl: isDarkTheme ? autoUploadModalImageDark : autoUploadModalImage,
        closable: true,
        closeOnEscape: true,
        closeOnDimmerClick: false,
        onClose: () => {
            sendDwh({
                eventCategory: 'modal',
                action: 'close',
                dwh_enabled: true,
                dwhData: {
                    name: analyticsName,
                },
            });
            if (reopenFreemiumAboutModal) {
                requestAnimationFrame(() => {
                    renderFreemiumAboutModal?.();
                });
            }
        },
    });
};
